import React, { useEffect } from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import '../styles/ExportVote.css';
import '../styles/BaseForm.css';
import '../styles/MediaSelect.css';
import fr from '../locales/fr';
import en from '../locales/en';


function MediaSelect() {
  const browserLang = navigator.language || navigator.userLanguage;
  const language = browserLang.startsWith('fr') ? 'fr' : 'en';
  const translations = language === 'fr' ? fr : en;

  const location = useLocation();

  // Autorisation via navigation OU refresh
  const allowed =
    location.state?.fromAuthorized ||
    sessionStorage.getItem('canAccessMediaSelect');

  useEffect(() => {
    if (allowed) {
      // Nettoyage après validation
      sessionStorage.removeItem('canAccessMediaSelect');
    }
  }, [allowed]);

  // Blocage accès direct par URL
  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  const allowNext = (key) => {
    sessionStorage.setItem(key, 'true');
  };

  return (
    <div className="boxform">
      <h1 className="title">{translations.mediaSelect.title}</h1>
      <div className="media-buttons-container">

        <Link
          to="/exportMot"
          state={{ fromMediaSelect: true }}
          onClick={() => allowNext('canAccessExportMot')}
          className="media-button media-button-yellow"
        >
          {translations.mediaSelect.word}
        </Link>

        <Link
          to="/exportImage"
          state={{ fromMediaSelect: true }}
          onClick={() => allowNext('canAccessExportImage')}
          className="media-button media-button-purple"
        >
          {translations.mediaSelect.image}
        </Link>

        {/* <Link
          to="/exportVideo"
          state={{ fromMediaSelect: true }}
          onClick={() => allowNext('canAccessExportVideo')}
          className="media-button media-button-pink"
        >
          {translations.mediaSelect.video}
        </Link> */}

        <Link
          to="/exportDessin"
          state={{ fromMediaSelect: true }}
          onClick={() => allowNext('canAccessExportDessin')}
          className="media-button media-button-blue"
        >
          {translations.mediaSelect.drawing}
        </Link>
      </div>
    </div>
  );
}

export default MediaSelect;
